import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { background_onboarding, logo } from '../../constants/icons';

const PlayerMandateKycRejected = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useParams();
  const {
    mobile,
    playerId,
    token: stateToken,
    verification,
    inviteParams,
    rawQuery,
    email,
    inviteSentBy,
    senderType,
    agencyId,
    type,
  } = location.state || {};

  const mandateToken = stateToken || token || null;

  const handleTryAgain = () => {
    const basePath = mandateToken
      ? `/player-register-mandate/${mandateToken}`
      : '/player-register-mandate';

    navigate(`${basePath}/verify`, {
      state: {
        token: mandateToken,
        mobile,
        playerId,
        verification,
        inviteParams,
        rawQuery,
        email,
        inviteSentBy,
        senderType,
        agencyId,
        type,
      },
    });
  };

  return (
    <div className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center p-4"
      style={{
        backgroundImage: `url(${background_onboarding})`,
      }}
    >
      <div className="bg-white p-8 w-full max-w-[544px] flex flex-col rounded-xl gap-6 items-center text-center">
        <img src={logo} alt="Transfer Pitch" className="h-10 mb-2 mx-auto" />
        <div className="flex items-center justify-center w-16 h-16 bg-red-100 rounded-2xl mb-4">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <div className="text-[#1A212F] text-2xl font-bold">Verification Not Approved</div>
        <div className="text-[#1A212F] text-base">
          Your identity verification was not approved. This could be due to unclear document images or missing information.
        </div>
        
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-left w-full">
          <h4 className="font-medium text-red-800 mb-2">Common reasons for rejection:</h4>
          <ul className="text-sm text-red-700 space-y-1">
            <li>• Document images are blurry or unclear</li>
            <li>• Document is expired or invalid</li>
            <li>• Personal information doesn't match</li>
            <li>• Required documents are missing</li>
          </ul>
        </div>
        
        <button
          type="button"
          onClick={handleTryAgain}
          className="w-full h-[44px] rounded-lg bg-[#2283FF] hover:bg-[#1a6cd4] text-white text-[14px] font-medium transition-colors"
        >
          Try Again
        </button>
        
        <p className="text-sm text-gray-500">
          Need help? Contact our support team for assistance with the verification process.
        </p>
      </div>
    </div>
  );
};

export default PlayerMandateKycRejected;